import React from 'react';
import { resolveFieldPlaceholder } from '../utils/formPlaceholders';

const Textarea = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  error = '',
  required = false,
  disabled = false,
  rows = 3,
  className = '',
  ...props
}) => {
  const resolvedPlaceholder = resolveFieldPlaceholder({ placeholder, label, name, type: 'textarea' });

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-bold text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={resolvedPlaceholder}
        disabled={disabled}
        rows={rows}
        className={`w-full px-4 py-3 border-2 rounded-2xl font-medium transition-all duration-300 resize-y min-h-[80px]
          ${error
            ? 'border-red-500 focus:border-red-600 focus:ring-4 focus:ring-red-500/20 bg-red-50/50'
            : 'border-gray-200 hover:border-gray-300 focus:border-red-500 focus:ring-4 focus:ring-red-500/20'
          }
          ${disabled
            ? 'bg-gray-100 cursor-not-allowed text-gray-500'
            : 'bg-white/50 backdrop-blur-sm text-gray-900 placeholder:text-gray-400 hover:bg-white'
          }
          focus:outline-none shadow-sm hover:shadow-md focus:shadow-xl focus:shadow-red-500/10 text-sm`}
        {...props}
      />
      {error && (
        <p className="mt-2 text-sm text-red-600 font-medium flex items-center gap-1">
          <span className="inline-block w-1 h-1 bg-red-600 rounded-full"></span>
          {error}
        </p>
      )}
    </div>
  );
};

export default Textarea;
